let navigation = [
    {
        url_key: 'playaway',
        name: 'Playaway',
        subnav: [
            {
                url_key: '/playaway/kids',
                name: 'Kids',
                pages: {
                    'New Releases': '/playaway/kids/new-releases',
                    'Pre-Order': '/playaway/kids/pre-order',
                    'Best Sellers': '/playaway/kids/best-sellers'
                }
            },
            {
                url_key: '/playaway/young-adult',
                name: 'YA',
                pages: {
                    'New Releases': '/playaway/young-adult/new-releases',
                    'Pre-Order': '/playaway/young-adult/pre-order',
                    'Best Sellers': '/playaway/young-adult/best-sellers'
                }
            },
            {
                url_key: '/playaway/adult',
                name: 'Adults',
                pages: {
                    'New Releases': '/playaway/adult/new-releases',
                    'Pre-Order': '/playaway/adult/pre-order',
                    'Best Sellers': '/playaway/adult/best-sellers'
                }
            },
            {
                url_key: '/playaway/feature-lists',
                name: 'Feature Lists',
                pages: {
                    'NYT Best Sellers': '/playaway/feature-lists/new-york-times-bestsellers',
                    'Editorial Picks': '/playaway/feature-lists/editorial-picks',
                    'Curated Content': '/curated-content'
                }
            },
            {
                name: 'Product Info',
                pages: {
                    'About Playaway': 'http://playaway.com/audiobooks',
                    'Using Playaway': 'https://shop-static.playaway.com/resources/Playaway_How_To_v2020.09.09.pdf',
                    Replacements: '/replacements',
                    'Need to Return a Unit?': '/support/returns'
                }
            }
        ]
    },
    {
        url_key: 'playaway-launchpad',
        name: 'Launchpad',
        subnav: [
            {
                url_key: '/playaway-launchpad/apps',
                name: 'Apps',
                pages: {
                    'Kids Collections': '/playaway-launchpad/kids/collections',
                    'Teen + Adult Collections': '/playaway-launchpad/teen-adult/collections',
                    'New Releases': '/playaway-launchpad/feature-lists/new-releases',
                    'Best Sellers': '/playaway-launchpad/feature-lists/best-sellers'
                }
            },
            {
                name: 'Launchpad Academy',
                url_key: '/playaway-launchpad/academy',
                pages: {
                    'Reading Academy': '/playaway-launchpad/collections/reading-academy',
                    'Pre-K Academy': '/playaway-launchpad/collections/pre-k-academy',
                    'STEAM Academy': '/playaway-launchpad/collections/steam-academy'
                }
            },
            {
                url_key: '/playaway-launchpad/videos',
                name: 'Video',
                pages: {
                    STEAM: '/playaway-launchpad/videos/steam',
                    'Movies & TV': '/playaway-launchpad/feature-lists/movies-and-tv',
                    'Early Literacy': '/playaway-launchpad/feature-lists/early-literacy',
                    'New Releases': '/playaway-launchpad/videos/new-releases',
                    'Best Sellers': '/playaway-launchpad/videos/best-sellers'
                }
            },
            {
                url_key: '/playaway-launchpad/feature-lists',
                name: 'Feature Lists',
                pages: {
                    'All Apps': '/playaway-launchpad/apps/all',
                    'All Comics': '/playaway-launchpad/comics/all',
                    'All Videos': '/playaway-launchpad/videos/all',
                    'Curated Content': '/curated-content'
                }
            },
            {
                name: 'Product Info',
                pages: {
                    'About Launchpad': 'http://playaway.com/launchpad',
                    'Using Launchpad': '/playaway-launchpad/using-playaway-launchpad',
                    Replacements: '/replacements',
                    'Need to Return a Unit?': '/support/returns'
                }
            }
        ]
    },
    {
        url_key: 'wonderbook',
        name: 'Wonderbook',
        subnav: [
            {
                url_key: '/wonderbook/categories',
                name: 'Categories',
                pages: {
                    'Picture Books': '/wonderbook/feature-lists/picture-books',
                    'Leveled Readers': '/wonderbook/feature-lists/leveled-readers',
                    'Early Chapter Books': '/wonderbook/feature-lists/early-chapter-books',
                    'Chapter Books': '/wonderbook/feature-lists/chapter-books',
                    Nonfiction: '/wonderbook/feature-lists/nonfiction',
                    'Spanish Language': '/wonderbook/feature-lists/bilingual-spanish'
                }
            },
            {
                // 'url_key': '/wonderbook/feature-lists',
                name: 'Feature Lists',
                pages: {
                    'New Releases': '/wonderbook/new-releases',
                    'Pre-Order': '/wonderbook/pre-order',
                    'Editorial Picks': '/wonderbook/feature-lists/editorial-picks',
                    'Curated Content': '/curated-content',
                    'Browse All': '/wonderbook'
                }
            },
            {
                name: 'Product Info',
                pages: {
                    'About Wonderbook': 'http://playaway.com/wonderbook',
                    'Using Wonderbook': 'https://shop-static.playaway.com/resources/how_to_use_wonderbook.pdf',
                    Replacements: '/replacements',
                    'Need to Return a Unit?': '/support/returns'
                }
            }
        ]
    },
    {
        url_key: 'playaway-bookpacks',
        name: 'Bookpacks',
        subnav: [
            {
                url_key: '/playaway-bookpacks/audience',
                name: 'Audience',
                pages: {
                    'Grades K-3': '/playaway-bookpacks/audience/grades-k-3',
                    'Grades 3-6': '/playaway-bookpacks/audience/grades-3-6',
                    YA: '/playaway-bookpacks/audience/young-adult'
                }
            },
            {
                url_key: '/playaway-bookpacks/feature-lists',
                name: 'Feature Lists',
                pages: {
                    'New Releases': '/playaway-bookpacks/feature-lists/new-releases',
                    'Page Turns': '/playaway-bookpacks/feature-lists/page-turns',
                    'Best Sellers': '/playaway-bookpacks/feature-lists/best-sellers',
                    'Archived Lists': '/archived-lists/bookpacks'
                }
            },
            {
                name: 'Product Info',
                pages: {
                    'About Bookpacks': 'http://playaway.com/bookpacks',
                    'Using Bookpacks': '/playaway-bookpacks/using-playaway-bookpacks',
                    Replacements: '/replacements',
                    'Need to Return a Unit?': '/support/returns'
                }
            }
        ]
    },
    // {
    //     name: 'Promos & Resources',
    //     subnav: [
    //         {
    //             name: 'Programs',
    //             pages: {
    //                 SOP: '/sop',
    //                 'Play It Forward': '/play-it-forward',
    //                 'Anytime Savings': '/anytime-savings'
    //             }
    //         },
    //         {
    //             name: 'Resources',
    //             pages: {
    //                 'Grant Resources': '/grant-resources',
    //                 'Find Your Rep': '/book-meeting',
    //                 'Curated Content': '/curated-content'
    //             }
    //         }
    //     ]
    // },
    {
        name: 'Accessories & Merchandising',
        subnav: [
            {
                name: 'Accessories',
                pages: {
                    All: '/accessories/all-accessories',
                    'Earbuds & Audio Cables': '/accessories/earbuds-and-audio-cables',
                    Packaging: '/accessories/packaging',
                    'Shelf-Ready Processing': '/shelf-ready-processing'
                }
            },
            {
                name: 'Merchandising',
                url_key: '/merchandising',
                pages: {
                    Playaway: '/merchandising/playaway-merchandising',
                    Launchpad: '/merchandising/launchpad',
                    Bookpacks: '/merchandising/bookpacks',
                    Wonderbook: '/merchandising/wonderbook',
                    'Social Media Kits': '/marketing-materials'
                }
            }
        ]
    }
];

export default navigation;
